// Можно передать одно значение или массив
export default function isBlankString(str) {
  let isArr = false;
  let isBlank = false;

  if (typeof Array.isArray === 'undefined') {
    isArr = Object.prototype.toString.call(str) === '[object Array]';
  } else {
    isArr = Array.isArray(str);
  }

  if (isArr) {
    for (let i = 0, len = str.length; i < len; i++) {
      if (!str[i] || /^\s*$/.test(str[i])) {
        isBlank = true;
        break;
      }
    }
  } else {
    isBlank = !str || /^\s*$/.test(str);
  }

  return isBlank;
}
